const EuphoricSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      {/* Face circle */}
      <circle
        cx="64"
        cy="64"
        r="30"
        fill="none"
        stroke="#063"
        strokeWidth="2"
      />
      {/* Eyes */}
      <circle cx="54" cy="56" r="2" fill="#063" />
      <circle cx="74" cy="56" r="2" fill="#063" />
      {/* Smile */}
      <path
        d="M52 72c4 6 16 6 24 0"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Calm waves (under the face) */}
      <path
        d="M40 100c6-4 12-4 18 0s12 4 18 0 12-4 18 0"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EuphoricSVG;
